/**
 * Whisper 文字起こしサービス
 * Vercel API Route /api/transcribe 経由で OpenAI Whisper API を呼ぶ
 */

const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN || localStorage.getItem('bangerfy_auth_token') || '';

function getApiKey(): string {
  // BYOK: OpenAI key stored in localStorage
  return localStorage.getItem('bangerfy_openai_key') || '';
}

export interface TranscribeResult {
  text: string;
}

export const whisperService = {
  async transcribe(audioBlob: Blob): Promise<TranscribeResult> {
    const formData = new FormData();
    formData.append('audio', audioBlob, 'recording.webm');

    const headers: Record<string, string> = {};

    if (AUTH_TOKEN) {
      headers['Authorization'] = `Bearer ${AUTH_TOKEN}`;
    }

    const apiKey = getApiKey();
    if (apiKey) {
      headers['X-API-Key'] = apiKey;
    }

    const res = await fetch('/api/transcribe', {
      method: 'POST',
      headers,
      body: formData,
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.error || `Transcription failed (${res.status})`);
    }

    const data = await res.json();
    return { text: data.text || '' };
  },
};
